import styled from 'styled-components'

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const Label = styled.div`
  font-weight: 600;
  font-size: 0.875rem;
`

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
`

export const Message = styled.div`
  padding: 1rem;
  font-size: 0.875rem;
`

export const Select = styled.select`
  padding: 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  background: ${({ theme }) => theme.forecast.cardGroupBackground};
  color: ${({ theme }) => theme.forecast.defaultText};
  font-size: 0.875rem;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.forecast.primary};
  }
`

export const ModalFooter = styled.div`
  display: flex;
  gap: 0.5rem;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid ${({ theme }) => theme.forecast.background3};
`
